import { createSlice } from '@reduxjs/toolkit';
import { fetchFantasyEvents } from './fantasyEvents';
const initialState = {
    byId: {}
};
const applyBoxscoreState = (state, boxscores) => {
    boxscores.forEach((boxscore) => {
        state.byId[boxscore.id] = boxscore;
    });
};
const boxscoresSlice = createSlice({
    name: 'boxscores',
    initialState,
    reducers: {
        setBoxScores: (state, action) => {
            applyBoxscoreState(state, action.payload);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchFantasyEvents.fulfilled, (state, action) => {
            applyBoxscoreState(state, action.payload.boxscores);
        });
    }
});
export const boxscoresReducer = boxscoresSlice.reducer;
export const setBoxScores = boxscoresSlice.actions.setBoxScores;
